import { useLocation } from "react-router-dom";
import styled from "styled-components";

interface InputWithLabelProps{
    type?:string
    label?:string,
    name?:string,
    value?:string,
    required?:boolean,
    placeholder?:string,
    disabled?:boolean
    onChange?:(event: React.ChangeEvent<HTMLInputElement>) => void
}

const InputWithLabel = ({type, required, label, name, value, placeholder, onChange, disabled}:InputWithLabelProps) => {
    const id = useLocation().state;
    return(
        <Container >
            <Label>{label}</Label>
            <Input type={type} required={required} name={name} value={value} onChange={onChange} disabled={(type==="password" && id) || disabled} placeholder={placeholder}/>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
`
const Label = styled.label`
    color: #0F172A;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
`
const Input = styled.input`
    height: 44px;
    padding-left: 12px;
    padding-right: 12px;
    border: 1px solid ${props => props.required ? "#DF0000" : "#E2E8F0"};
    border-radius: 8px;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    color: #0F172A;
    background: #FFFFFF;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #DF0000;
        box-shadow: 0 0 0 3px rgba(223, 0, 0, 0.12);
    }

    &:disabled {
        background: #F1F5F9;
        color: #94A3B8;
        cursor: not-allowed;
    }

    &::placeholder {
        color: #94A3B8;
    }
`

export default InputWithLabel;